import { render } from "./CommerceClientSearch.vue?vue&type=template&id=283c68ad"
import script from "./CommerceClientSearch.vue?vue&type=script&lang=js"
export * from "./CommerceClientSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__